<template>
	<div class="login_wrap">
		<template v-if="showLoginBtn">
			<li class="dropdown notification-list" v-if="Object.keys(userInfo).length">
				<el-dropdown>
					<a
						class="nav-link dropdown-toggle nav-user arrow-none mr-0"
						data-toggle="dropdown"
						id="topbar-userdrop"
						href="javascript:void(0);"
						role="button"
						aria-haspopup="true"
						aria-expanded="false"
					>
						<span class="account-user-avatar">
							<img
								:src="userInfo.headImage ? `${this.uploadUrl}/upload/download?id=${userInfo.headImage}&openStyle=1` : require('@/assets/images/users/avatar-1.jpg')"
								alt="user-image"
								class="rounded-circle"
							/>
						</span>
						<span style="height: 45px;line-height: 45px; display: block;">{{ userInfo.realName }}</span>
						<!-- <span class="account-position">{{ userInfo.unitName }}</span> -->
						<i class="mdi mdi-chevron-down float-right"></i>
					</a>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item>
							<div @click="goMyCenter">
								<i class="mdi mdi-account-circle mr-1"></i>
								<span>个人中心</span>
							</div>
						</el-dropdown-item>
						<el-dropdown-item>
							<div @click="dialogForgetShow = true">
								<i class="mdi mdi-database-lock mr-1"></i>
								<span>修改密码</span>
							</div>
						</el-dropdown-item>
						<el-dropdown-item>
							<div @click="handleDropOut">
								<i class="dripicons-power mr-1"></i>
								<span>退出系统</span>
							</div>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</li>
			<li class="dropdown notification-list" v-else>
				<a class="nav-link right-bar-toggle nav-home" href="javascript: void(0);" data-toggle="modal" data-target="#login-modal" @click="openLoginDialog">
					<!-- <i class="fa fa-user-circle-o noti-icon"></i> -->
					<span class="align-middle">登录</span>
				</a>
			</li>
		</template>

		<!-- 登录窗口 -->
		<el-dialog title="" :visible.sync="dialogLoginShow" width="450px" :close-on-click-modal="false">
			<div class="modal-body login_box" style="padding:0 1rem">
				<div class="text-center font-weight-bold login-tit"><a href="javascript:void(0);" class="text-success">用户登录</a></div>
				<el-form :model="loginForm" :rules="loginRules" ref="login" label-width="80px">
					<el-form-item label="账号" prop="username"><el-input v-model="loginForm.username" placeholder="请输入登录账号" style="width:260px"></el-input></el-form-item>
					<el-form-item label="密码" prop="password">
						<el-input
							@keyup.enter.native="loginSubmitForm"
							v-model="loginForm.password"
							type="password"
							autocomplete="off"
							placeholder="请输入登录密码"
							style="width:260px"
						></el-input>
					</el-form-item>
				</el-form>
				<div class="form-group">
					<div class="custom-checkbox">
						<el-checkbox v-model="rememberVal">记住账号</el-checkbox>
						<!-- <a
							class="float-right"
							href="javascript: void(0);"
							@click="
								dialogLoginShow = false;
								dialogForgetShow = true;
							"
						>
							忘记密码
						</a> -->
					</div>
				</div>
				<div slot="footer" class="dialog-footer"><el-button class="btn btn-rounded btn-primary w-100" type="primary" round @click="loginSubmitForm">登录</el-button></div>
			</div>
			<!-- 图像验证码 -->
			<el-dialog width="370px" title="" :visible.sync="loginInnerVisible" append-to-body :close-on-click-modal="false">
				<Verify @success="loginVerificationSuccess" :mode="'fixed'" :captchaType="'blockPuzzle'" :imgSize="{ width: '330px', height: '155px' }" ref="verify"></Verify>
			</el-dialog>
		</el-dialog>
		<!-- end 登录窗口 -->

		<!-- 修改密码 -->
		<!--  :close-on-click-modal="false" -->
		<el-dialog title="" :visible.sync="dialogForgetShow" width="550px" :before-close="dialogClose">
			<div class="modal-body forget_box">
				<div class="text-center font-weight-bold login-tit"><a href="javascript:void(0);" class="text-success">修改密码</a></div>
				<el-form :model="forgetForm" :rules="forgetRules" ref="forgetFormRef" label-width="120px">
					<el-form-item label="旧密码" prop="oldPassword">
						<el-input v-model="forgetForm.oldPassword" show-password placeholder="请输入旧密码" style="width:86%"></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="newPassword">
						<el-input v-model="forgetForm.newPassword" show-password placeholder="请输入新密码" style="width:86%"></el-input>
					</el-form-item>
					<el-form-item label="确认新密码" prop="confirmPassword">
						<el-input v-model="forgetForm.confirmPassword" show-password placeholder="请确认密码" style="width:86%"></el-input>
					</el-form-item>
					<!-- <el-form-item label="姓名：" prop="name">
            <el-input v-model="forgetForm.username" placeholder="请输入真实姓名" style="width:86%"></el-input>
          </el-form-item>
          <el-form-item label="登录账号：">
            <el-input v-model="forgetForm.username" placeholder="请输入登录账号" style="width:86%"></el-input>
          </el-form-item>
          <el-form-item label="手机号码：">
            <el-input v-model="forgetForm.username" placeholder="请输入手机密码" style="width:86%"></el-input>
          </el-form-item>
          <el-form-item label="短信验证码：">
            <el-input v-model="forgetForm.captchaVerification" type="password" autocomplete="off" placeholder="请输入验证码" style="width:86%"></el-input>
          </el-form-item> -->
				</el-form>
				<div slot="footer" class="dialog-footer"><el-button class="btn btn-rounded btn-primary w-100" type="primary" round @click="forgetSubmitForm">提交</el-button></div>
			</div>
			<el-dialog width="30%" title="" :visible.sync="forgetInnerVisible" append-to-body :close-on-click-modal="false">
				<Verify @success="forgetVerificationSuccess" :mode="'fixed'" :captchaType="'blockPuzzle'" :imgSize="{ width: '330px', height: '155px' }" ref="verify1"></Verify>
			</el-dialog>
		</el-dialog>
		<!-- end 忘记密码 -->
	</div>
</template>
<script>
import { login, getUserInfo, getBackstageMenuList, editPsd } from '@/api/after/login';
import { initDynamicRoutes } from '@/router/index.js';
import Verify from '@/components/verifition/Verify';
export default {
	components: { Verify },
	props: {
		isDialogLoginShow: {
			type: Boolean,
			default: false
		},
		url: {
			type: String,
			default: ''
		},
		showLoginBtn: {
			type: Boolean,
			default: true
		}
	},
	data() {
		var validatePassword = (rule, value, callback) => {
			let regexp = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{8,}$/;
		  if (this.actionType === "修改用户") {
		    if (!value) {
		      callback();
		    } else if (regexp.test(value)) {
					callback();
		    } else {
					callback(new Error("密码至少包括英文、数字或特殊符合组合，不得少于8位"));
		    }
		  } else {
		    if (!value) {
		      callback(new Error("请输入密码"));
		    } else if (regexp.test(value)) {
					callback();
		    } else {
					callback(new Error("密码至少包括英文、数字或特殊符合组合，不得少于8位"));
		    }
		  }
		};
		var validateConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入确认密码！'));
			} else if (value === this.forgetForm.newPassword) {
				callback();
			} else {
				callback(new Error('两次密码不相同！'));
			}
		};
		return {
			// 登录
			dialogLoginShow: this.isDialogLoginShow,
			routerPath: this.url,
			loginInnerVisible: false,
			loginForm: {
				username: '',
				password: '',
				captchaVerification: ''
			},
			loginRules: {
				username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
			},
			rememberVal: false, //记住账号
			// 忘记密码
			dialogForgetShow: false,
			forgetInnerVisible: false,
			forgetForm: {
				oldPassword: '',
				newPassword: '',
				confirmPassword: ''
				// name: "",
				// username: "",
				// phone: "",
				// captchaVerification: "",
			},
			forgetRules: {
				oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }, { min: 6, message: '密码至少6位数', trigger: 'blur' }],
				// newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { min: 6, message: '密码至少6位数', trigger: 'blur' }],
				newPassword: [{ required: true, validator: validatePassword, trigger: 'blur' }],
				confirmPassword: [
					{
						required: true,
						validator: validateConfirmPassword,
						trigger: 'blur'
					}
				]
			},
			//用户信息
			userInfo: {}
		};
	},
	watch: {
		isDialogLoginShow: function(val) {
			this.dialogLoginShow = val;
		},
		dialogLoginShow: function(val) {
			this.$emit('dialogloginshow', val);
		},
		url: function(val) {
			this.routerPath = val;
		}
	},
	created() {
		this.userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {};
		let userName = localStorage.getItem('userName');
		if (userName) {
			this.rememberVal = true;
			this.loginForm.username = userName;
		}
	},
	methods: {
		// 打开登陆窗口
		openLoginDialog(){
			this.dialogLoginShow = true
			this.loginForm.username = localStorage.getItem('userName')
		},
		//登录
		loginVerificationSuccess(params) {
			this.loginForm.captchaVerification = params.captchaVerification;
			this.loginInnerVisible = false;
			this.$refs.login.validate(valid => {
				if (valid) {
					this.loginFn();
				} else {
					//   this.$message.error("请输入账号密码");
					console.log('error submit!!');
					return false;
				}
			});
		},
		loginSubmitForm() {
			
			if (!this.loginForm.captchaVerification) {
				this.loginInnerVisible = true;
				return;
			}
			this.$refs.login.validate(valid => {
				if (valid) {
					this.loginFn();
				} else {
					//   this.$message.error("请输入账号密码");
					console.log('error submit!!');
					return false;
				}
			});
		},
		loginFn() {
			login(this.loginForm).then(res => {
				console.log(res);
				if (res.code == 200) {
					this.$message.success('登录成功');
					if (this.rememberVal) {
						localStorage.setItem('userName', this.loginForm.username);
					} else {
						localStorage.removeItem('userName');
					}
					sessionStorage.setItem('token', res.data);
					this.loginForm = {
						username: '',
						password: '',
						captchaVerification: '',
					}
					this.rememberVal = false
					this.$emit('login');
					this.dialogLoginShow = false;
					this.getUserInfo();
					this.getBackstageMenuList();
					if (this.routerPath) {
						this.$router.push(this.routerPath);
					}
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 用户信息
		async getUserInfo() {
			const res = await getUserInfo();
			if (res.code == 200) {
				this.userInfo = res.data;
				if (this.userInfo.birthday) {
					if(this.userInfo.birthday.length === 10){
						this.userInfo.birthday = this.userInfo.birthday + ' 00:00:00'
					}
				}
				sessionStorage.setItem('userInfo', JSON.stringify(res.data));
			} else {
				this.$message.error(res.message);
			}
		},
		// 路由菜单
		async getBackstageMenuList() {
			const res = await getBackstageMenuList();
			if (res.code == 200) {
				console.log(res.data);
				// this.$store.commit("setMenuList", res.data);
				sessionStorage.setItem('menuList', JSON.stringify(res.data));
				initDynamicRoutes(); // 初始化路由
			} else {
				this.$message.error(res.message);
			}
		},

		//退出系统
		handleDropOut() {
			this.userInfo = {};
			sessionStorage.removeItem('userInfo');
			sessionStorage.removeItem('token');
			sessionStorage.removeItem('menuList');
			sessionStorage.removeItem('curOneNavIndex');
			sessionStorage.removeItem('curTwoNavIndex');
			this.$router.push('/index');
			this.$message.success('退出登录成功！');
			this.$emit('logout');
			// window.location.reload();
		},
		// 忘记密码
		forgetVerificationSuccess(params) {
			this.forgetForm.captchaVerification = params.captchaVerification;
			this.forgetInnerVisible = false;
		},
		forgetSubmitForm() {
			// if (!this.forgetForm.captchaVerification) {
			//   this.forgetInnerVisible = true;
			//   return;
			// }
			this.$refs.forgetFormRef.validate(valid => {
				if (valid) {
					this.forgetFn();
				} else {
					//   this.$message.error("请输入账号密码");
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 修改密码
		async forgetFn() {
			const res = await editPsd(this.forgetForm);
			if (res.code == 200) {
				this.$message({
					type:'success',
					message:'密码修改成功！',
					duration:1000,
					onClose:()=>{
						this.dialogForgetShow = false
						// this.userInfo = {};
						// sessionStorage.removeItem('userInfo');
						// sessionStorage.removeItem('token');
						// sessionStorage.removeItem('menuList');
						// sessionStorage.removeItem('curOneNavIndex');
						// sessionStorage.removeItem('curTwoNavIndex');
						// this.$router.push('/index');
						// this.$emit('logout');
						// if (this.$route.path === '/index') {
						// 	//如果是当前页面，重新加载页面
						// 	window.location.reload();
						// }
					}
				})
			} else {
				this.$message.error(res.data);
			}
		},
		dialogClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		// 跳转到个人信息
		goMyCenter() {
			this.$router.push('/myCenter');
		}
	}
};
</script>
<style scoped lang="scss">
.login_wrap {
 	::v-deep .el-dialog__header {
		display: block;
	}
}
.text-success {
	letter-spacing: 20px;
}
</style>
